var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"grey--text"},[_vm._v(_vm._s(_vm.note.user_name)+" | "+_vm._s(_vm._f("datetime")(_vm.note.created_at))+" ")]),_c('div',{staticStyle:{"white-space":"pre-wrap"},domProps:{"innerHTML":_vm._s(_vm.note.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }